import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output
} from '@angular/core'
import { WsConnectionService } from '../../../services/ws-connection.service'
import { Router } from '@angular/router'
import { MessageEnvelope, TransferMessageData } from '../../message.types'

@Component({
  selector: 'app-transfer-notification',
  templateUrl: './transfer-notification.component.html',
  styleUrls: ['./transfer-notification.component.scss']
})
export class TransferNotificationComponent implements OnInit, AfterViewInit {
  @Output() public dismissed: EventEmitter<any> = new EventEmitter()
  public data: MessageEnvelope<TransferMessageData>

  constructor(
    private wsConnectionService: WsConnectionService,
    private router: Router
  ) {}

  public dismiss(event: Event): void {
    event.preventDefault()
    this.dismissed.emit()
  }

  ngOnInit(): void {
    this.data = this.wsConnectionService.message$.getValue()
    console.log('ngOnInit data is', this.data)
  }

  accept(event) {
    console.log('Joining call', this.data)
    this.dismiss(event)
    const sessionId = this.data?.message?.sessionId
    if (sessionId) {
      this.router.navigate(['telehealth'], {
        queryParams: { sessionId: sessionId }
      })
    }
  }

  decline(event) {
    console.log('Declining call', this.data)
    this.dismiss(event)
    // TODO message back
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit data is', this.data)
  }
}
